import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';

import { createLinks } from './links/create-links';

const GRAPHQL_CLIENT_NAME = 'Bitbucket Front End';
const SERVICE_NAME = 'bbc-frontbucket';
const PRODUCT_NAME = 'Bitbucket';
const BUSINESS_UNIT = 'Engineering-Bitbucket';
const COST_CENTER = 3346;

type CreateApolloClientOptions = {
  frontbucketVersion: string;
  hasWebsocketSubscriptions?: boolean;
};

export function createApolloClient({
  frontbucketVersion,
  hasWebsocketSubscriptions = false,
}: CreateApolloClientOptions) {
  const headers: Record<string, string> = {
    'atl-client-name': GRAPHQL_CLIENT_NAME,
    'atl-client-version': frontbucketVersion,
    'atl-attribution': JSON.stringify({
      product: PRODUCT_NAME,
      service: SERVICE_NAME,
      businessUnit: BUSINESS_UNIT,
      costCenter: COST_CENTER,
    }),
  };

  return new ApolloClient({
    connectToDevTools: process.env.NODE_ENV !== 'production',
    link: createLinks(headers, hasWebsocketSubscriptions),
    cache: new InMemoryCache(),
  });
}
